const formatLicenseKey = (key, width = 5) => {
  const normalizedKey = key === null || key === undefined ? '' : String(key)
  let formattedKey = ''

  for (let i = 0; i < normalizedKey.length; i += width) {
    let slice = normalizedKey.slice(i, i + width)
    if (i + width < normalizedKey.length) {
      slice += '-'
    }

    formattedKey += slice
  }

  return formattedKey
}

export default formatLicenseKey
